import React,{Component} from 'react';
import { connect } from 'react-redux';
import { logout } from "../../../actions/userAction";
import { NavLink,withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class Header extends Component {
	constructor(props, context) {
    super(props, context);
    this.state = {
      show: true,
	  visible: false
    };
        this.handleClick = this.handleClick.bind(this)
  }
  handleClick() {
    	this.setState({ visible: ! this.state.visible });
    }
	componentDidMount(){
		const currentUrl = (this.props.location);
		if(currentUrl.pathname==="/publicAccess")
		{
			this.setState({show: false});
		}
	}
	render(){
		return (
			
			<header role="banner" className="header-wrapper no-bg">


				{/* <div className="urgentBanner">
							<p>ePortal is temporarily unable to accept any e-filed documents. We apologize for the inconvenience.
							If you need to file a document immediately, please contact your Judge Assistant.</p>
						</div> */}

                <div className="header">
					<div className="container">
                        <div className="col-xs-3">
                            <a ui-sref="home" className="logo" ><img src="/app/static/media/osah-logo.png" alt="OSAH Georgia office of state administrative hearings" /></a>
                        </div>
												<div id="menu-toggle" onClick={this.handleClick} aria-controls="nav" aria-label="Navigation Menu" aria-expanded="false" className = {this.state.visible?'open':''}>
													<div id="hamburger">
												<span></span>
												<span></span>
												<span></span>
											</div>
											<div id="cross">
												<span></span>
												<span></span>
											</div>
												</div>
												
												
												

                        <ReactCSSTransitionGroup transitionName="navlogoutwrapper" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
						<div className={"navlogoutwrapper "+(this.state.visible?'active':'')}>
													<div className="col-xs-7">
															<nav className="navigation" role="navigation" id="nav">
																	<ul id="main-nav-label" role="menubar">
																			{this.state.show ? <li role="menuitem"><NavLink activeClassName={"active"} exact={true} to="/publicAccess/dashboard/open">MY DASHBOARD</NavLink></li> : <li role="menuitem"><a>MY DASHBOARD</a></li>}
										{this.state.show ? <li role="menuitem"><NavLink activeClassName={"active"} exact={true} to="/publicAccess/documentActivity">DOCUMENT ACTIVITY</NavLink></li> : <li role="menuitem"><a>DOCUMENT ACTIVITY</a></li>}
																			<li role="menuitem"><NavLink activeClassName={"active"} to="/publicAccess/account">ACCOUNT</NavLink></li>
																	</ul>
															</nav>
													</div>
													<div className="col-xs-2">
															<a aria-label="Logout" href="javascript:;" onClick={() => {this.props.logout()}} className="logout"><i className="fa fa-sign-out" aria-hidden="true"></i> LOGOUT</a>
													</div>
												</div></ReactCSSTransitionGroup>
                    </div>
						</div> 
            </header>
		)
	}
}
function mapStateToProps(state) {
	return {};
}
export default withRouter(connect(mapStateToProps, {logout})(Header));